import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <p class="alert alert-warn" ng-transclude></p>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/alert/warning/index.js